import { configureStore } from "@reduxjs/toolkit";
import screenSizeReducer from "./";
import filtersReducer from "./filters";
import StatesReducer from "./states";
import cameraReducer from "./camera";
import screenReducer from "./screenInnerWidth";
import largeScreenReducer from "./isLargeScreen";

export default configureStore({
  reducer: {
    screenSize: screenSizeReducer,
    states: StatesReducer,
    filters: filtersReducer,
    camera: cameraReducer,
    innerWidth: screenReducer,
    isLargeScreen: largeScreenReducer,
  },
});
